import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';

const InstallationConsiderations = () => {
  return (
    <div className={styles['article-page']}>
      <div className={styles.page}>
        <header className={styles['article-header']}>
          <SiteTopNav variant="light" />
        </header>

        <main className={styles['article-main']}>
          <Link className={styles['article-back']} to="/academy/hardwood-basics">
            ← Back to Flooring 101
          </Link>

          <p className={styles['article-eyebrow']} data-motion="copy">
            Sakura Floors Academy
          </p>

          <h1 className={styles['article-title']} data-motion="hero">
            Installation Considerations
          </h1>

          <p className={styles['article-intro']} data-motion="copy">
            The right installation method depends on your subfloor, moisture conditions, and how the
            space will be used.
          </p>

          <p className={styles['article-intro']} data-motion="copy">
            Getting installation right is just as important as choosing the right floor — it
            directly affects comfort, sound, and long-term performance.
          </p>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Methods</p>

            <h2 className={styles['article-section__title']}>Installation Methods</h2>

            <div className={styles['article-feature-list']}>
              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Glue-Down</h3>
                <p className={styles['article-feature__text']}>
                  Adds stability and sound dampening, well suited to concrete subfloors.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Nail-Down</h3>
                <p className={styles['article-feature__text']}>
                  A traditional method for plywood subfloors, offering a solid underfoot feel.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Floating</h3>
                <p className={styles['article-feature__text']}>
                  A flexible option that installs over most subfloor types with minimal preparation.
                </p>
              </div>
            </div>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Subfloors</p>

            <h2 className={styles['article-section__title']}>Subfloor and Site Conditions</h2>

            <p className={styles['article-section__text']}>
              Every subfloor type calls for its own preparation and installation approach.
            </p>

            <ul className={styles['article-list']}>
              <li>Plywood subfloors — commonly paired with nail-down installation</li>
              <li>Concrete slabs — typically require glue-down or floating installation</li>
              <li>Radiant heat systems — need a construction and adhesive rated for the system</li>
            </ul>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Preparation</p>

            <h2 className={styles['article-section__title']}>Before Installation Begins</h2>

            <p className={styles['article-section__text']}>
              A successful installation starts well before the first plank goes down.
            </p>

            <ul className={styles['article-list']}>
              <li>Moisture testing — confirms the subfloor is dry enough to proceed</li>
              <li>
                Acclimation — gives the flooring time to adjust to the room&rsquo;s conditions
              </li>
              <li>Subfloor flatness — uneven subfloors should be leveled before installation</li>
              <li>
                Installer experience — hardwood installation quality depends heavily on expertise
              </li>
            </ul>
          </section>
        </main>
      </div>
    </div>
  );
};

export default InstallationConsiderations;
